// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'

// Reducers
import { reducers as operatorReducers } from 'hfty-operator-asset-migrate'

export default createReducer({
  ...initialState,
}, {
  ...operatorReducers,
})
